module.exports = __webpack_public_path__ + "img/icona-05shuiyinguanlibeifen.7074aaab.png";